const secteurs = [
  "Activités juridiques et comptables",
  "Agriculture et élevage",
  "Architecture, études et normes",
  "Artisanat d'art, audiovisuel et spectacle",
  "Automobile",
  "Bâtiment et travaux publics (BTP)",
  "Commerce et distribution",
  "Communication et marketing",
  "Culture et patrimoine",
  "Édition",
  "Énergie",
  "Enseignement et formation",
  "Environnement",
  "Finance, banque et assurance",
  "Gestion administrative et ressources humaines",
  "Hôtellerie et restauration",
  "Immobilier",
  "Industrie - Alimentaire",
  "Industrie - Bois",
  "Industrie - Chimie",
  "Industrie - Électronique",
  "Industrie - Métallurgie",
  "Industrie - Papier et imprimerie",
  "Industrie - Textile et mode",
  "Industries",
  "Informatique et télécommunication",
  "Logistique et transport",
  "Maintenance, entretien et nettoyage",
  "Recherche",
  "Santé",
  "Service à la personne",
  "Service public, défense et sécurité",
  "Social",
  "Sport, animation et loisir",
  "Tourisme",
  "Autres",
];

export default secteurs;
